import React from 'react';

type AppDialogHeaderProps = {
    title?: string;
    stickyHeader?: boolean;
    children?: React.ReactNode;
};

const AppDialogHeader: React.FC<AppDialogHeaderProps> = ({ title, stickyHeader, children }) => {
    return (
        <header className={`${stickyHeader ? 'sticky-top' : ''} border-0 mb-0 text-center text-white`}>
            {children ?? (
                <h3 className="font-22 font-500 text-uppercase mb-0">{title}</h3>
            )}
        </header>
    );
};

export default AppDialogHeader;
